import shareIcon from 'url:../img/icons/menu-share.svg';
import createStoryIcon from 'url:../img/icons/menu-create-story.svg';
import deleteIcon from 'url:../img/icons/menu-delete.svg';
import downloadIcon from 'url:../img/icons/menu-download.svg';
import clearIcon from 'url:../img/icons/clear.svg';
import doneIcon from 'url:../img/icons/done.svg';
import paymentIcon from 'url:../img/icons/icon-payment-white.svg';

const actionPanelCSSPath = '.action-panel';
const showActionPanelClassName = 'action-panel_show';
const disabledBtnClassName = 'action-button_disabled';
const hiddenBtnClassName = 'action-button_hidden';
const getIdName = (id) => `action-panel-${id}`;

const getItem = (id) => document.querySelector(`#${getIdName(id)}`);

const getItemText = (id) => document.querySelector(`#${getIdName(id)} .action-button__text`);

const icons = {
  share: shareIcon,
  createStory: createStoryIcon,
  payment: paymentIcon,
  delete: deleteIcon,
  clear: clearIcon,
  done: doneIcon,
  download: downloadIcon,
};

const getIconSrcByName = (name) => {
  if (!icons[name]) return null;
  return icons[name];
};

export function initActionPanel() {
  return {
    onClickBtn,
    onClickBtnOnce,
    enableBtn,
    disableBtn,
    hideBtn,
    showBtn,
    updateBtnText,
    render,
    show,
    hide,
    isDisabledBtn,
  };

  function onClickBtn(id, cb) {
    const $elem = getItem(id);
    $elem.addEventListener('click', cb);
  }

  function onClickBtnOnce(id, cb) {
    const $elem = getItem(id);
    $elem.addEventListener('click', cb, { once: true });
  }

  function disableBtn(id) {
    const $elem = getItem(id);
    $elem.classList.add(disabledBtnClassName);
  }

  function isDisabledBtn(id) {
    const $elem = getItem(id);
    return $elem.classList.contains(disabledBtnClassName);
  }

  function enableBtn(id) {
    const $elem = getItem(id);
    $elem.classList.remove(disabledBtnClassName);
  }

  function hideBtn(id) {
    const $elem = getItem(id);
    $elem.classList.add(hiddenBtnClassName);
  }

  function showBtn(id) {
    const $elem = getItem(id);
    $elem.classList.remove(hiddenBtnClassName);
  }

  function updateBtnText(id, text) {
    const $elem = getItemText(id);
    $elem.innerHTML = text;
  }

  function render(list) {
    const $elem = document.querySelector(actionPanelCSSPath);
    $elem.innerHTML = list.reduce((acc, data) => acc + item(data), '');
  }

  function show() {
    const $elem = document.querySelector(actionPanelCSSPath);
    $elem.classList.add(showActionPanelClassName);
  }

  function hide() {
    const $elem = document.querySelector(actionPanelCSSPath);
    $elem.classList.remove(showActionPanelClassName);
  }

  function item({ id, iconName, text }) {
    return `
           <button class="action-button" id="${getIdName(id)}">
               <img class="action-button__img" src="${getIconSrcByName(iconName)}" alt="icon ${iconName}" />
               <span class="action-button__text">${text}</span>
           </button>
    `;
  }
}
